module.exports = __webpack_public_path__ + "img/Apoptosis-OVCA_10X_TPCP.e9d603eb.png";